// dashboard-agent-ia/src/pages/Landing.js
import React, { useEffect, useState, useRef } from 'react'
import { Link } from 'react-router-dom'
import { MdSmartToy } from 'react-icons/md'

const LANGS = [
  { code: 'fr', countryCode: 'fr', label: 'FR', name: 'Français' },
  { code: 'en', countryCode: 'gb', label: 'EN', name: 'English' },
  { code: 'wo', countryCode: 'sn', label: 'WO', name: 'Wolof' },
]

const T = {
  fr: {
    badge: 'Disponible au Sénégal • 500+ entreprises connectées',
    hero_title1: 'Votre assistant WhatsApp',
    hero_title2: 'intelligent',
    hero_title3: 'pour',
    hero_sub: "L'IA répond à vos clients 24h/24 en wolof, français et anglais. Pendant que vous dormez, votre business travaille.",
    cta_start: 'Commencer gratuitement →',
    cta_demo: 'Voir une démo',
    nav_features: 'Fonctionnalités',
    nav_prices: 'Tarifs',
    nav_contact: 'Contact',
    nav_login: 'Connexion',
    nav_start: 'Commencer →',
    stats: ['Entreprises', 'Disponible', 'Langues', 'Réponse'],
    features_title: 'Tout ce dont votre business a besoin',
    features_sub: "Un agent IA complet, formé sur votre secteur d'activité.",
    plans_title: 'Choisissez votre plan',
    plans_sub: 'Sans engagement. Changez de plan à tout moment.',
    footer_copy: '© 2026 LeBinaire · Agent IA',
    see_features: 'Voir les fonctionnalités →',
    section_features: 'Fonctionnalités',
    live_preview: 'Aperçu réel',
    testimonials_title: "Ce qu'ils disent",
    section_prices: 'Tarifs',
    prices_title: 'Simple et transparent',
    prices_sub: 'Résiliable à tout moment. Sans engagement.',
    prices_note: 'Pas de carte bancaire • Configuration en 5 minutes',
    wa_section_label: 'Innovation mondiale',
    wa_section_title: 'Le premier moteur de recherche WhatsApp',
    wa_section_sub: "Envoyez un message au +221 78 827 02 02. Notre IA trouve les meilleurs businesses pour vous — ou cherche sur le web si besoin.",
    wa_try: 'Tester maintenant sur WhatsApp',
    wa_how: 'Comment ça marche',
    wa_step1_title: 'Vous envoyez un message',
    wa_step1_sub: 'En wolof, français ou anglais',
    wa_step2_title: "L'IA comprend et cherche",
    wa_step2_sub: 'Dans notre base + sur le web',
    wa_step3_title: 'Vous recevez la réponse',
    wa_step3_sub: 'En moins de 2 secondes, 24h/24',
    wa_badge: 'Disponible maintenant',
  },
  en: {
    badge: 'Available in Senegal • 500+ connected businesses',
    hero_title1: 'Your WhatsApp assistant',
    hero_title2: 'intelligent',
    hero_title3: 'for',
    hero_sub: 'AI responds to your clients 24/7 in Wolof, French and English. While you sleep, your business works.',
    cta_start: 'Start for free →',
    cta_demo: 'See a demo',
    nav_features: 'Features',
    nav_prices: 'Pricing',
    nav_contact: 'Contact',
    nav_login: 'Login',
    nav_start: 'Get started →',
    stats: ['Businesses', 'Available', 'Languages', 'Response'],
    features_title: 'Everything your business needs',
    features_sub: 'A complete AI agent, trained on your industry.',
    plans_title: 'Choose your plan',
    plans_sub: 'No commitment. Change plan anytime.',
    footer_copy: '© 2026 LeBinaire · Agent IA',
    see_features: 'See features →',
    section_features: 'Features',
    live_preview: 'Live preview',
    testimonials_title: 'What they say',
    section_prices: 'Pricing',
    prices_title: 'Simple and transparent',
    prices_sub: 'Cancel anytime. No commitment.',
    prices_note: 'No credit card • Setup in 5 minutes',
    wa_section_label: 'Global innovation',
    wa_section_title: 'The first WhatsApp search engine',
    wa_section_sub: "Send a message to +221 78 827 02 02. Our AI finds the best businesses for you — or searches the web if needed.",
    wa_try: 'Test now on WhatsApp',
    wa_how: 'How it works',
    wa_step1_title: 'You send a message',
    wa_step1_sub: 'In Wolof, French or English',
    wa_step2_title: 'AI understands and searches',
    wa_step2_sub: 'In our database + on the web',
    wa_step3_title: 'You get the answer',
    wa_step3_sub: 'In less than 2 seconds, 24/7',
    wa_badge: 'Available now',
  },
  wo: {
    badge: 'Am na ci Sénégal • 500+ entreprise yi ñu jëkkël',
    hero_title1: 'Sa assistant WhatsApp',
    hero_title2: 'bu xam-xam',
    hero_title3: 'ci',
    hero_sub: 'IA bi dafa tontu ay xel-xel yi ci wolof, français ak anglais, 24h/24. Bu ngay nelaw, sa liggéey dafa dem.',
    cta_start: 'Tànn ci kanam →',
    cta_demo: 'Xool démo bi',
    nav_features: 'Ay jëf',
    nav_prices: 'Prix yi',
    nav_contact: 'Jëfandikoo',
    nav_login: 'Duggël',
    nav_start: 'Tànn →',
    stats: ['Entreprise yi', 'Am na', 'Làkk yi', 'Tontu'],
    features_title: 'Bëpp li sa liggéey soxor',
    features_sub: 'Agent IA bu dëkk, bu jàng ci sa domaine.',
    plans_title: 'Tànn sa plan',
    plans_sub: 'Amul engagement. Soppi plan ak ndaw.',
    footer_copy: '© 2026 LeBinaire · Agent IA',
    see_features: 'Xool ay jëf yi →',
    section_features: 'Ay jëf',
    live_preview: 'Xool bu dëkk',
    testimonials_title: 'Luy naan ñu',
    section_prices: 'Prix yi',
    prices_title: 'Sedd ak xam-xam',
    prices_sub: 'Jëfandikoo. Amul engagement.',
    prices_note: 'Amul carte bancaire • Seetanal ci 5 minit',
    wa_section_label: 'Innovation bu aduna',
    wa_section_title: 'WhatsApp moteur yu jiitu ci aduna',
    wa_section_sub: "Yónni xbaar ci +221 78 827 02 02. IA bi dafa seet liggéey yi dul baax — wala dafa dem ci web.",
    wa_try: 'Seetanal ci WhatsApp',
    wa_how: 'Naka lañu def',
    wa_step1_title: 'Yónnee xbaar bi',
    wa_step1_sub: 'Ci wolof, français wala anglais',
    wa_step2_title: 'IA bi xam ak seet',
    wa_step2_sub: 'Ci base bi ak ci web',
    wa_step3_title: 'Jël tontu bi',
    wa_step3_sub: 'Ci kanam 2 saa, 24h/24',
    wa_badge: 'Am na léegi',
  },
}

const SECTORS = [
  { label: 'Immobilier & BTP' },
  { label: 'Santé & Clinique' },
  { label: 'Restaurant & Food' },
  { label: 'Tourisme & Voyage' },
  { label: 'Boutique & Mode' },
  { label: 'Transport & Logistique' },
  { label: 'Digital & Tech' },
  { label: 'Événements & Mariages' },
  { label: 'Pharmacie & Para-pharma' },
  { label: 'Éducation & Formation' },
  { label: 'Beauté & Coiffure' },
  { label: 'Assurance & Finance' },
  { label: 'Agriculture & Élevage' },
  { label: 'Juridique & Conseil' },
  { label: 'Électronique & Télécom' },
  { label: 'Quincaillerie & Matériaux' },
  { label: 'Automobile & Garage' },
  { label: 'Traiteur & Catering' },
  { label: 'Sport & Fitness' },
  { label: 'Imprimerie & Communication' },
]

const STATS = [
  { value: '500+', label: 'Entreprises', icon: '🏢' },
  { value: '24/7', label: 'Disponible', icon: '⚡' },
  { value: '3', label: 'Langues', icon: '🌍' },
  { value: '< 2s', label: 'Réponse', icon: '🚀' },
]

const getPlans = (prices) => [
  {
    name: 'Starter', price: Number(prices.starterPrice).toLocaleString('fr-FR'), color: '#3b82f6',
    desc: 'Pour démarrer simplement',
    features: ['💬 Réponses texte uniquement', 'FAQ intelligente', 'Compétences IA', 'Leads automatisés', '1 000 messages/mois', 'Support Email'],
  },
  {
    name: 'Pro', price: Number(prices.proPrice).toLocaleString('fr-FR'), color: '#8b5cf6', popular: true,
    desc: 'Pour les PME ambitieuses',
    features: ['💬 Texte + 🎵 Audio WhatsApp', 'Tout Starter +', 'Devis PDF automatique', 'Catalogue produits', 'Suivi commandes', '5 000 messages/mois', 'Support prioritaire'],
  },
  {
    name: 'Premium', price: Number(prices.premiumPrice).toLocaleString('fr-FR'), color: '#f59e0b',
    desc: 'Pour les grandes structures',
    features: ['💬 Texte + 🎵 Audio + 📸 Images', 'Tout Pro +', 'RDV Calendrier IA', 'Emails automatiques', 'Relances IA', 'Messages illimités', 'Support dédié 24/7'],
  },
]

const FEATURES = [
  { icon: '✨', title: 'IA conversationnelle', desc: 'Réponses naturelles, précises, adaptées à votre secteur.' },
  { icon: '🌍', title: 'Wolof · Français · Anglais', desc: 'L\'IA détecte automatiquement la langue et répond dans la même.' },
  { icon: '📊', title: 'Dashboard complet', desc: 'Statistiques, conversations, relances, modèles — tout depuis un seul tableau de bord.' },
  { icon: '📅', title: 'Calendrier RDV', desc: 'Gestion visuelle des rendez-vous avec confirmation automatique par email et WhatsApp.' },
  { icon: '📋', title: 'Devis PDF pro', desc: 'Génère des devis professionnels avec logo, NINEA, pied de page — en 1 clic.' },
  { icon: '🔄', title: 'Relances automatiques', desc: 'L\'IA relance vos clients inactifs au bon moment, avec le bon message.' },
]

const TESTIMONIALS = [
  { name: 'Moussa Diallo', company: 'Merco Immo Dakar', sector: '🏠 Immobilier', text: 'Notre agent IA répond aux demandes de visite la nuit. On ne perd plus aucun lead !', avatar: 'MD' },
  { name: 'Dr. Fatou Sène', company: 'Clinique Santé Plus', sector: '🏥 Santé', text: 'Les RDV sont confirmés automatiquement. Nos patients adorent la réactivité.', avatar: 'FS' },
  { name: 'Ibrahima Ba', company: 'Travel Sénégal', sector: '✈️ Tourisme', text: 'On reçoit 3x plus de demandes de devis qu\'avant. L\'IA qualifie chaque prospect.', avatar: 'IB' },
]

const API_URL = process.env.REACT_APP_API_URL || 'https://agent-ia-senegal.onrender.com'

export default function Landing() {
  const [scrollY, setScrollY] = useState(0)
  const [lang, setLang] = useState(localStorage.getItem('lang') || 'fr')

  // ── Prix dynamiques depuis config admin ──
  const [platformPrices, setPlatformPrices] = useState({
    starterPrice: 15000, proPrice: 35000, premiumPrice: 65000, trialDays: 14
  })
  // ── Numéro universel dynamique depuis config admin ──
  const [waNumber, setWaNumber] = useState('+221 78 827 02 02')
  const [waNumberRaw, setWaNumberRaw] = useState('221788270202')

  useEffect(() => {
    fetch(API_URL + '/api/admin/config')
      .then(function(r) { return r.json() })
      .then(function(data) {
        if (data.starterPrice) {
          setPlatformPrices({
            starterPrice: data.starterPrice,
            proPrice: data.proPrice,
            premiumPrice: data.premiumPrice,
            trialDays: data.trialDays || 14,
          })
        }
        if (data.universalNumber) {
          setWaNumber(data.universalNumber)
          setWaNumberRaw(data.universalNumber.replace(/\D/g, ''))
        }
      })
      .catch(function() {})
  }, [])

  const [translating, setTranslating] = useState(false)
  const [woTranslations, setWoTranslations] = useState(() => {
    try { return JSON.parse(localStorage.getItem('wo_translations') || 'null') }
    catch { return null }
  })

  const t = lang === 'wo' && woTranslations ? woTranslations : (T[lang] || T.fr)

  const translateToWolof = async () => {
    if (woTranslations) return
    setTranslating(true)
    try {
      const res = await fetch(API_URL + '/api/translate', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ texts: T.fr, targetLang: 'wo' })
      })
      const data = await res.json()
      if (data.translations) {
        setWoTranslations(data.translations)
        localStorage.setItem('wo_translations', JSON.stringify(data.translations))
      }
    } catch (e) {
      setWoTranslations(T.wo)
      localStorage.setItem('wo_translations', JSON.stringify(T.wo))
    } finally {
      setTranslating(false)
    }
  }

  const handleLang = (code) => {
    setLang(code)
    localStorage.setItem('lang', code)
    if (code === 'wo') translateToWolof()
    window.dispatchEvent(new Event('lang-changed'))
  }

  const [sectorIdx, setSectorIdx] = useState(0)
  const heroRef = useRef(null)

  useEffect(() => {
    const onScroll = () => setScrollY(window.scrollY)
    window.addEventListener('scroll', onScroll)
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  useEffect(() => {
    const interval = setInterval(() => setSectorIdx(i => (i + 1) % SECTORS.length), 2000)
    return () => clearInterval(interval)
  }, [])

  return (
    <div style={{ background: 'linear-gradient(135deg,#0f172a,#1e1b4b,#0f172a)', minHeight: '100vh', color: 'white', fontFamily: "'Plus Jakarta Sans', sans-serif", overflowX: 'hidden' }}>
      <link href="https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap" rel="stylesheet"/>

      {/* ── NAV ── */}
      <nav style={{
        position: 'fixed', top: 0, left: 0, right: 0, zIndex: 100,
        background: scrollY > 50 ? 'rgba(3,7,18,0.95)' : 'transparent',
        backdropFilter: scrollY > 50 ? 'blur(20px)' : 'none',
        borderBottom: scrollY > 50 ? '1px solid rgba(255,255,255,0.06)' : 'none',
        transition: 'all 0.3s',
        padding: '0 40px', height: '68px', display: 'flex', alignItems: 'center', justifyContent: 'space-between'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <div style={{ width: 40, height: 40, borderRadius: 12, background: 'linear-gradient(135deg,#3b82f6,#1d4ed8)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
            <MdSmartToy size={22} style={{ color: 'white' }}/>
          </div>
          <span style={{ fontWeight: 800, fontSize: 18, letterSpacing: '-0.5px' }}>Agent <span style={{ color: '#a78bfa' }}>IA</span> Sénégal</span>
        </div>
        <div style={{ display: 'flex', gap: 16, alignItems: 'center' }}>
          <div style={{ display: 'flex', gap: 24, alignItems: 'center' }}>
            <a href="#fonctionnalités" style={{ color: 'rgba(255,255,255,0.6)', textDecoration: 'none', fontSize: 14, fontWeight: 500 }}>{t.nav_features}</a>
            <a href="#tarifs" style={{ color: 'rgba(255,255,255,0.6)', textDecoration: 'none', fontSize: 14, fontWeight: 500 }}>{t.nav_prices}</a>
            <a href="#contact" style={{ color: 'rgba(255,255,255,0.6)', textDecoration: 'none', fontSize: 14, fontWeight: 500 }}>{t.nav_contact}</a>
            <Link to="/login" style={{ color: 'rgba(255,255,255,0.7)', textDecoration: 'none', fontSize: 14, fontWeight: 500 }}>{t.nav_login}</Link>
          </div>
          <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
            {translating && (
              <span style={{ fontSize: 11, color: '#25d366', fontWeight: 600 }}>🔄 Traduction...</span>
            )}
            {LANGS.map(l => (
              <button key={l.code} onClick={() => handleLang(l.code)} title={l.name}
                style={{
                  display: 'flex', alignItems: 'center', gap: 6,
                  padding: '6px 12px', borderRadius: 20, cursor: 'pointer',
                  background: lang === l.code ? 'rgba(59,130,246,0.25)' : 'rgba(255,255,255,0.07)',
                  color: lang === l.code ? 'white' : 'rgba(255,255,255,0.5)',
                  fontSize: 13, fontWeight: lang === l.code ? 700 : 500,
                  transition: 'all 0.2s',
                  border: lang === l.code ? '1px solid rgba(59,130,246,0.5)' : '1px solid rgba(255,255,255,0.1)',
                }}>
                <img src={'https://flagcdn.com/20x15/' + l.countryCode + '.png'} alt={l.label} width={20} height={15} style={{ borderRadius: 2, objectFit: 'cover' }}/>
                <span>{l.label}</span>
              </button>
            ))}
          </div>
          <Link to="/inscription" style={{
            background: 'linear-gradient(135deg,#3b82f6,#1d4ed8)', color: 'white',
            padding: '10px 18px', borderRadius: 10, textDecoration: 'none', fontSize: 13, fontWeight: 700,
            boxShadow: '0 4px 20px rgba(59,130,246,0.3)', whiteSpace: 'nowrap'
          }}>{t.nav_start}</Link>
        </div>
      </nav>

      {/* ── HERO ── */}
      <section ref={heroRef} style={{ position: 'relative', minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center', padding: 'clamp(80px,10vw,120px) clamp(16px,5vw,40px) 60px', overflow: 'hidden' }}>
        <div style={{ position: 'absolute', inset: 0, background: 'radial-gradient(ellipse 80% 60% at 50% -10%, rgba(59,130,246,0.12) 0%, transparent 70%)', pointerEvents: 'none' }}/>
        <div style={{ position: 'absolute', top: '20%', left: '5%', width: 300, height: 300, background: 'radial-gradient(circle, rgba(139,92,246,0.08) 0%, transparent 70%)', pointerEvents: 'none' }}/>
        <div style={{ position: 'absolute', top: '30%', right: '5%', width: 250, height: 250, background: 'radial-gradient(circle, rgba(59,130,246,0.08) 0%, transparent 70%)', pointerEvents: 'none' }}/>
        <div style={{ position: 'absolute', inset: 0, backgroundImage: 'radial-gradient(rgba(255,255,255,0.03) 1px, transparent 1px)', backgroundSize: '32px 32px', pointerEvents: 'none' }}/>

        <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8, background: 'rgba(59,130,246,0.1)', border: '1px solid rgba(59,130,246,0.25)', borderRadius: 100, padding: '8px 20px', marginBottom: 32 }}>
          <div style={{ width: 6, height: 6, borderRadius: '50%', background: '#3b82f6', animation: 'pulse 2s infinite' }}/>
          <span style={{ fontSize: 13, fontWeight: 600, color: '#60a5fa' }}>{t.badge}</span>
        </div>

        <h1 style={{ fontSize: 'clamp(42px, 7vw, 80px)', fontWeight: 800, lineHeight: 1.05, letterSpacing: '-2px', marginBottom: 20, maxWidth: 900 }}>
          Votre assistant WhatsApp{' '}
          <span style={{ background: 'linear-gradient(135deg,#3b82f6,#60a5fa)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
            intelligent
          </span>{' '}
          pour{' '}
          <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8, background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 12, padding: '2px 16px', transition: 'all 0.5s' }}>
            {SECTORS[sectorIdx].label}
          </span>
        </h1>

        <p style={{ fontSize: 20, color: 'rgba(255,255,255,0.55)', maxWidth: 600, lineHeight: 1.6, marginBottom: 48, fontWeight: 400 }}>
          {t.hero_sub}
        </p>

        <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', justifyContent: 'center', marginBottom: 80 }}>
          <Link to="/inscription" style={{
            background: 'linear-gradient(135deg,#3b82f6,#1d4ed8)', color: 'white',
            padding: '16px 36px', borderRadius: 14, textDecoration: 'none', fontSize: 16, fontWeight: 700,
            boxShadow: '0 8px 30px rgba(59,130,246,0.35)', transition: 'transform 0.2s'
          }} onMouseEnter={e => e.currentTarget.style.transform='translateY(-2px)'}
            onMouseLeave={e => e.currentTarget.style.transform='translateY(0)'}>
            🚀 Démarrer gratuitement
          </Link>
          <a href="#fonctionnalités" style={{
            background: 'rgba(255,255,255,0.06)', color: 'white', border: '1px solid rgba(255,255,255,0.12)',
            padding: '16px 36px', borderRadius: 14, textDecoration: 'none', fontSize: 16, fontWeight: 600,
          }}>{t.see_features}</a>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 10, maxWidth: 500, width: '100%' }}>
          {STATS.map((s, i) => (
            <div key={i} style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: 16, padding: '20px 32px', textAlign: 'center', minWidth: 120 }}>
              <div style={{ fontSize: 24 }}>{s.icon}</div>
              <div style={{ fontSize: 28, fontWeight: 800, color: '#60a5fa', letterSpacing: '-1px' }}>{s.value}</div>
              <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.45)', marginTop: 4 }}>{t.stats[i] || s.label}</div>
            </div>
          ))}
        </div>
      </section>

      {/* ── SECTEURS ── */}
      <section style={{ padding: 'clamp(40px,5vw,60px) clamp(16px,5vw,40px)', borderTop: '1px solid rgba(255,255,255,0.05)' }}>
        <p style={{ textAlign: 'center', color: 'rgba(255,255,255,0.35)', fontSize: 13, fontWeight: 600, letterSpacing: 2, textTransform: 'uppercase', marginBottom: 32 }}>
          Adapté à tous les secteurs
        </p>
        <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', justifyContent: 'center' }}>
          {SECTORS.map((s, i) => (
            <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 8, background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.07)', borderRadius: 100, padding: '10px 20px' }}>
              <span style={{ fontSize: 14, color: 'rgba(255,255,255,0.65)', fontWeight: 500 }}>{s.label}</span>
            </div>
          ))}
        </div>
      </section>

      {/* ── MOTEUR WHATSAPP ── */}
      <section style={{ padding: 'clamp(60px,8vw,100px) clamp(16px,5vw,40px)', position: 'relative', overflow: 'hidden' }}>
        <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%,-50%)', width: 600, height: 600, background: 'radial-gradient(circle, rgba(37,211,102,0.06) 0%, transparent 70%)', pointerEvents: 'none' }}/>
        <div style={{ maxWidth: 1200, margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: 64 }}>
            <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8, background: 'rgba(37,211,102,0.1)', border: '1px solid rgba(37,211,102,0.25)', borderRadius: 100, padding: '6px 18px', marginBottom: 20 }}>
              <div style={{ width: 7, height: 7, borderRadius: '50%', background: '#25d366', animation: 'pulse 2s infinite' }}/>
              <span style={{ fontSize: 13, fontWeight: 700, color: '#25d366' }}>{t.wa_badge}</span>
            </div>
            <p style={{ fontSize: 13, fontWeight: 700, color: '#25d366', letterSpacing: 2, textTransform: 'uppercase', marginBottom: 12 }}>{t.wa_section_label}</p>
            <h2 style={{ fontSize: 'clamp(28px,5vw,52px)', fontWeight: 800, letterSpacing: '-1.5px', marginBottom: 20, lineHeight: 1.1 }}>
              {t.wa_section_title} <span style={{ background: 'linear-gradient(135deg,#25d366,#128c7e)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>d'Afrique</span>
            </h2>
            <p style={{ color: 'rgba(255,255,255,0.55)', fontSize: 18, maxWidth: 640, margin: '0 auto 32px', lineHeight: 1.7 }}>
              {(t.wa_section_sub || '').replace('+221 78 827 02 02', waNumber)}
            </p>

            {/* Numéro cliquable — dynamique */}
            <a href={'https://wa.me/' + waNumberRaw + '?text=Bonjour%2C%20je%20teste%20Agent%20IA%20S%C3%A9n%C3%A9gal%20!'} target="_blank" rel="noreferrer"
              style={{ display: 'inline-flex', alignItems: 'center', gap: 12, background: 'linear-gradient(135deg,#25d366,#128c7e)', color: 'white', padding: '16px 32px', borderRadius: 16, textDecoration: 'none', fontWeight: 700, fontSize: 18, boxShadow: '0 8px 32px rgba(37,211,102,0.35)', transition: 'all 0.2s' }}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="white"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
              {waNumber}
            </a>
            <p style={{ marginTop: 12, fontSize: 13, color: 'rgba(255,255,255,0.35)' }}>{t.wa_try}</p>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(280px,1fr))', gap: 24, marginBottom: 64 }}>
            {[
              { num: '01', title: t.wa_step1_title, sub: t.wa_step1_sub, color: '#25d366' },
              { num: '02', title: t.wa_step2_title, sub: t.wa_step2_sub, color: '#3b82f6' },
              { num: '03', title: t.wa_step3_title, sub: t.wa_step3_sub, color: '#f59e0b' },
            ].map((step, i) => (
              <div key={i} style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.07)', borderRadius: 20, padding: '28px 24px', display: 'flex', alignItems: 'flex-start', gap: 16 }}>
                <div style={{ width: 48, height: 48, borderRadius: 14, background: step.color + '18', color: step.color, display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 900, fontSize: 16, flexShrink: 0, border: '1px solid ' + step.color + '33' }}>
                  {step.num}
                </div>
                <div>
                  <p style={{ fontWeight: 700, fontSize: 16, color: 'white', marginBottom: 6 }}>{step.title}</p>
                  <p style={{ fontSize: 14, color: 'rgba(255,255,255,0.5)', lineHeight: 1.6 }}>{step.sub}</p>
                </div>
              </div>
            ))}
          </div>

          <div style={{ maxWidth: 480, margin: '0 auto' }}>
            <div style={{ borderRadius: 24, overflow: 'hidden', boxShadow: '0 24px 64px rgba(0,0,0,0.4)', border: '1px solid rgba(255,255,255,0.08)' }}>
              <div style={{ background: '#075e54', padding: '12px 16px', display: 'flex', alignItems: 'center', gap: 10 }}>
                <div style={{ width: 38, height: 38, borderRadius: '50%', background: 'linear-gradient(135deg,#25d366,#128c7e)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <MdSmartToy size={20} style={{ color: 'white' }}/>
                </div>
                <div>
                  <p style={{ color: 'white', fontWeight: 700, fontSize: 14, margin: 0 }}>Agent IA Sénégal</p>
                  <p style={{ color: 'rgba(255,255,255,0.7)', fontSize: 11, margin: 0 }}>{waNumber} • En ligne</p>
                </div>
              </div>
              <div style={{ background: '#e5ddd5', padding: 16, display: 'flex', flexDirection: 'column', gap: 10 }}>
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <div style={{ background: '#dcf8c6', borderRadius: '16px 16px 4px 16px', padding: '10px 14px', maxWidth: '80%', boxShadow: '0 1px 2px rgba(0,0,0,0.15)' }}>
                    <p style={{ margin: 0, fontSize: 14, color: '#111' }}>Bonjour, je cherche un appartement F5 à Dakar Almadies</p>
                    <p style={{ margin: '4px 0 0', fontSize: 10, color: '#666', textAlign: 'right' }}>09:14 ✓✓</p>
                  </div>
                </div>
                <div style={{ display: 'flex', justifyContent: 'flex-start', gap: 8, alignItems: 'flex-end' }}>
                  <div style={{ width: 28, height: 28, borderRadius: '50%', background: '#075e54', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                    <MdSmartToy size={16} style={{ color: 'white' }}/>
                  </div>
                  <div style={{ background: 'white', borderRadius: '16px 16px 16px 4px', padding: '10px 14px', maxWidth: '85%', boxShadow: '0 1px 2px rgba(0,0,0,0.15)' }}>
                    <p style={{ margin: 0, fontSize: 14, color: '#111', lineHeight: 1.6 }}>
                      Bonjour ! J'ai trouvé <strong>3 agences immobilières</strong> dans notre réseau pour un F5 Almadies :<br/><br/>
                      🏠 <strong>Merco Immo</strong> — Spécialiste Almadies<br/>
                      📞 +221 77 XXX XX XX<br/><br/>
                      Souhaitez-vous plus de détails ou un autre secteur ?
                    </p>
                    <p style={{ margin: '4px 0 0', fontSize: 10, color: '#666', textAlign: 'right' }}>09:14 ✓✓</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── FONCTIONNALITÉS ── */}
      <section id="fonctionnalités" style={{ padding: 'clamp(60px,8vw,100px) clamp(16px,5vw,40px)', maxWidth: 1200, margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: 72 }}>
          <p style={{ color: '#60a5fa', fontSize: 13, fontWeight: 700, letterSpacing: 2, textTransform: 'uppercase', marginBottom: 12 }}>{t.section_features}</p>
          <h2 style={{ fontSize: 'clamp(32px, 5vw, 52px)', fontWeight: 800, letterSpacing: '-1.5px', marginBottom: 16 }}>{t.features_title}</h2>
          <p style={{ color: 'rgba(255,255,255,0.45)', fontSize: 18, maxWidth: 500, margin: '0 auto' }}>{t.features_sub}</p>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(340px, 1fr))', gap: 20 }}>
          {FEATURES.map((f, i) => (
            <div key={i} style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.07)', borderRadius: 20, padding: '32px', transition: 'border-color 0.3s' }}
              onMouseEnter={e => e.currentTarget.style.borderColor='rgba(59,130,246,0.25)'}
              onMouseLeave={e => e.currentTarget.style.borderColor='rgba(255,255,255,0.07)'}>
              <div style={{ fontSize: 40, marginBottom: 20 }}>{f.icon}</div>
              <h3 style={{ fontSize: 18, fontWeight: 700, marginBottom: 10 }}>{f.title}</h3>
              <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: 15, lineHeight: 1.65 }}>{f.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* ── DEMO WHATSAPP ── */}
      <section style={{ padding: 'clamp(50px,6vw,80px) clamp(16px,5vw,40px)', background: 'rgba(255,255,255,0.02)', borderTop: '1px solid rgba(255,255,255,0.05)', borderBottom: '1px solid rgba(255,255,255,0.05)' }}>
        <div style={{ maxWidth: 900, margin: '0 auto', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: 40, alignItems: 'center' }}>
          <div>
            <p style={{ color: '#60a5fa', fontSize: 13, fontWeight: 700, letterSpacing: 2, textTransform: 'uppercase', marginBottom: 16 }}>{t.live_preview}</p>
            <h2 style={{ fontSize: 40, fontWeight: 800, letterSpacing: '-1px', marginBottom: 20, lineHeight: 1.1 }}>Comme si c'était vous qui répondiez</h2>
            <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: 16, lineHeight: 1.7, marginBottom: 32 }}>L'IA comprend le contexte, retient les informations du client et répond de manière naturelle — même en wolof.</p>
            {['Répond en < 2 secondes', 'Mémorise chaque client', "S'adapte à votre secteur", 'Personnalité configurable'].map((f, i) => (
              <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 14 }}>
                <div style={{ width: 22, height: 22, borderRadius: '50%', background: 'rgba(59,130,246,0.15)', border: '1px solid rgba(59,130,246,0.3)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, color: '#3b82f6' }}>✓</div>
                <span style={{ fontSize: 15, color: 'rgba(255,255,255,0.75)' }}>{f}</span>
              </div>
            ))}
          </div>
          <div style={{ background: '#0a1628', borderRadius: 24, overflow: 'hidden', border: '1px solid rgba(255,255,255,0.08)', boxShadow: '0 40px 80px rgba(0,0,0,0.4)' }}>
            <div style={{ background: '#075e54', padding: '16px 20px', display: 'flex', alignItems: 'center', gap: 12 }}>
              <div style={{ width: 40, height: 40, borderRadius: '50%', background: 'rgba(255,255,255,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 20 }}>🏢</div>
              <div>
                <div style={{ color: 'white', fontWeight: 700, fontSize: 15 }}>Merco Immo</div>
                <div style={{ color: 'rgba(255,255,255,0.7)', fontSize: 12 }}>Agent IA • En ligne</div>
              </div>
            </div>
            <div style={{ padding: 20, background: '#e5ddd5', minHeight: 280 }}>
              {[
                { from: 'client', text: 'Bonjour, avez-vous des appartements à louer à Almadies ?' },
                { from: 'ia', text: 'Bonjour ! Oui, nous avons plusieurs biens disponibles aux Almadies 🏠\n\nF3 meublé : 350 000 FCFA/mois\nF4 avec parking : 500 000 FCFA/mois\n\nVoulez-vous organiser une visite cette semaine ?' },
                { from: 'client', text: 'Oui, je suis disponible jeudi matin' },
                { from: 'ia', text: 'Parfait ! Je vous confirme un créneau jeudi à 10h00 🗓️\n\nVotre email pour la confirmation ?' },
              ].map((msg, i) => (
                <div key={i} style={{ display: 'flex', justifyContent: msg.from === 'ia' ? 'flex-start' : 'flex-end', marginBottom: 12 }}>
                  <div style={{ background: msg.from === 'ia' ? 'white' : '#dcf8c6', padding: '10px 14px', borderRadius: msg.from === 'ia' ? '12px 12px 12px 2px' : '12px 12px 2px 12px', maxWidth: '80%', fontSize: 13, color: '#1a1a1a', lineHeight: 1.5, boxShadow: '0 1px 2px rgba(0,0,0,0.1)', whiteSpace: 'pre-line' }}>
                    {msg.text}
                    <div style={{ fontSize: 10, color: '#999', marginTop: 4, textAlign: 'right' }}>09:3{i} ✓✓</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ── TESTIMONIALS ── */}
      <section style={{ padding: 'clamp(60px,8vw,100px) clamp(16px,5vw,40px)', maxWidth: 1100, margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: 60 }}>
          <h2 style={{ fontSize: 40, fontWeight: 800, letterSpacing: '-1px' }}>{t.testimonials_title}</h2>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: 20 }}>
          {TESTIMONIALS.map((item, i) => (
            <div key={i} style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: 20, padding: 32 }}>
              <div style={{ fontSize: 24, marginBottom: 16 }}>⭐⭐⭐⭐⭐</div>
              <p style={{ color: 'rgba(255,255,255,0.7)', fontSize: 15, lineHeight: 1.7, marginBottom: 24, fontStyle: 'italic' }}>"{item.text}"</p>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <div style={{ width: 44, height: 44, borderRadius: '50%', background: 'linear-gradient(135deg,#3b82f6,#1d4ed8)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 14 }}>{item.avatar}</div>
                <div>
                  <div style={{ fontWeight: 700, fontSize: 15 }}>{item.name}</div>
                  <div style={{ color: 'rgba(255,255,255,0.4)', fontSize: 13 }}>{item.company}</div>
                  <div style={{ fontSize: 12, color: '#60a5fa', marginTop: 2 }}>{item.sector}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ── TARIFS ── */}
      <section id="tarifs" style={{ padding: 'clamp(60px,8vw,100px) clamp(16px,5vw,40px)', background: 'rgba(255,255,255,0.02)', borderTop: '1px solid rgba(255,255,255,0.05)' }}>
        <div style={{ textAlign: 'center', marginBottom: 72 }}>
          <p style={{ color: '#60a5fa', fontSize: 13, fontWeight: 700, letterSpacing: 2, textTransform: 'uppercase', marginBottom: 12 }}>{t.section_prices}</p>
          <h2 style={{ fontSize: 'clamp(32px, 5vw, 52px)', fontWeight: 800, letterSpacing: '-1.5px', marginBottom: 16 }}>{t.prices_title}</h2>
          <p style={{ color: 'rgba(255,255,255,0.45)', fontSize: 18 }}>{t.prices_sub}</p>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: 16, maxWidth: 1000, margin: '0 auto' }}>
          {getPlans(platformPrices).map((plan, i) => (
            <div key={i} style={{
              background: plan.popular ? 'rgba(139,92,246,0.06)' : 'rgba(255,255,255,0.03)',
              border: '1px solid ' + (plan.popular ? plan.color : 'rgba(255,255,255,0.08)'),
              borderRadius: 24, padding: '40px 36px',
              position: 'relative', transform: plan.popular ? 'scale(1.03)' : 'none',
              boxShadow: plan.popular ? ('0 0 60px ' + plan.color) : 'none'
            }}>
              {plan.popular && (
                <div style={{ position: 'absolute', top: -14, left: '50%', transform: 'translateX(-50%)', background: plan.color, color: 'white', fontSize: 12, fontWeight: 700, padding: '6px 20px', borderRadius: 100, whiteSpace: 'nowrap' }}>
                  ⭐ Le plus populaire
                </div>
              )}
              <div style={{ fontSize: 13, fontWeight: 700, color: plan.color, marginBottom: 8, textTransform: 'uppercase', letterSpacing: 1 }}>{plan.name}</div>
              <div style={{ marginBottom: 8 }}>
                <span style={{ fontSize: 44, fontWeight: 800, letterSpacing: '-2px' }}>{plan.price}</span>
                <span style={{ color: 'rgba(255,255,255,0.4)', fontSize: 15 }}> FCFA/mois</span>
              </div>
              <p style={{ color: 'rgba(255,255,255,0.45)', fontSize: 14, marginBottom: 32 }}>{plan.desc}</p>
              {plan.features.map((f, fi) => (
                <div key={fi} style={{ display: 'flex', gap: 10, marginBottom: 14, alignItems: 'center' }}>
                  <span style={{ color: plan.color, fontSize: 14 }}>✓</span>
                  <span style={{ color: 'rgba(255,255,255,0.7)', fontSize: 14 }}>{f}</span>
                </div>
              ))}
              <Link to="/inscription" style={{
                display: 'block', textAlign: 'center', marginTop: 32,
                background: plan.popular ? plan.color : 'rgba(255,255,255,0.08)',
                color: 'white', padding: '14px', borderRadius: 12, textDecoration: 'none', fontWeight: 700, fontSize: 15,
                boxShadow: plan.popular ? ('0 8px 24px ' + plan.color) : 'none'
              }}>Commencer</Link>
            </div>
          ))}
        </div>
      </section>

      {/* ── CTA FINAL ── */}
      <section style={{ padding: 'clamp(60px,8vw,100px) clamp(16px,5vw,40px)', textAlign: 'center', position: 'relative', overflow: 'hidden' }}>
        <div style={{ position: 'absolute', inset: 0, background: 'radial-gradient(ellipse 60% 50% at 50% 50%, rgba(59,130,246,0.08) 0%, transparent 70%)', pointerEvents: 'none' }}/>
        <h2 style={{ fontSize: 'clamp(36px, 6vw, 64px)', fontWeight: 800, letterSpacing: '-2px', marginBottom: 20 }}>
          Prêt à automatiser<br/>votre service client ?
        </h2>
        <p style={{ color: 'rgba(255,255,255,0.45)', fontSize: 20, marginBottom: 48 }}>
          Rejoignez 500+ entrepreneurs sénégalais qui font confiance à Agent IA.
        </p>
        <Link to="/inscription" style={{
          background: 'linear-gradient(135deg,#3b82f6,#1d4ed8)', color: 'white',
          padding: '20px 56px', borderRadius: 16, textDecoration: 'none', fontSize: 18, fontWeight: 800,
          boxShadow: '0 12px 40px rgba(59,130,246,0.4)', display: 'inline-block'
        }}>🚀 Créer mon compte gratuitement</Link>
        <p style={{ color: 'rgba(255,255,255,0.25)', fontSize: 14, marginTop: 20 }}>{t.prices_note}</p>
      </section>

      {/* ── FOOTER ── */}
      <footer id="contact" style={{ borderTop: '1px solid rgba(255,255,255,0.06)', padding: 'clamp(40px,5vw,60px) clamp(16px,5vw,40px)', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 24 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <div style={{ width: 36, height: 36, borderRadius: 10, background: 'linear-gradient(135deg,#3b82f6,#1d4ed8)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><MdSmartToy size={20} style={{color:'white'}}/></div>
          <div>
            <div style={{ fontWeight: 800, fontSize: 16 }}>Agent IA Sénégal</div>
            <div style={{ color: 'rgba(255,255,255,0.35)', fontSize: 13 }}>by LeBinaire · Dakar, Sénégal</div>
          </div>
        </div>
        <div style={{ color: 'rgba(255,255,255,0.3)', fontSize: 13 }}>© 2026 Agent IA Sénégal. Tous droits réservés.</div>
        <div style={{ display: 'flex', gap: 24 }}>
          <Link to="/conditions" style={{ color: 'rgba(255,255,255,0.35)', textDecoration: 'none', fontSize: 13 }}>Conditions</Link>
          <Link to="/confidentialite" style={{ color: 'rgba(255,255,255,0.35)', textDecoration: 'none', fontSize: 13 }}>Confidentialité</Link>
          <Link to="/contact" style={{ color: 'rgba(255,255,255,0.35)', textDecoration: 'none', fontSize: 13 }}>Contact</Link>
        </div>
      </footer>

      <style>{`
        @keyframes pulse { 0%, 100% { opacity: 1 } 50% { opacity: 0.4 } }
        @media (max-width: 640px) {
          .nav-links { display: none !important; }
          .footer-links { flex-direction: column; align-items: center; gap: 8px; }
        }
      `}</style>

      {scrollY > 400 && (
        <button onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          style={{ position: 'fixed', bottom: 28, right: 28, zIndex: 99, width: 48, height: 48, borderRadius: '50%', background: 'linear-gradient(135deg,#3b82f6,#1d4ed8)', color: 'white', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 20px rgba(59,130,246,0.5)', transition: 'all 0.2s', fontSize: 22, fontWeight: 700 }}
          onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.1)'}
          onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
          title="Retour en haut">↑</button>
      )}
    </div>
  )
}
